'use client';

import { useRouter } from 'next/navigation';
import { AppNextLink } from '@/features/app-next-link';
import { IconArrowRight1, IconSearchNormal } from '@/features/icons';
import { useCartReturnUrl } from '@/app/(order)/cart/_utils/use-cart-return-url';
import { OrderPagesURL } from '@/app/(order)/types';
import CartCounterButton from '@/app/(pdp)/_components/buttons/add-to-cart-button/cart-counter-button';
import { useSearchModal } from '../../search';
import { usePagePathDataProvider } from '../../utils/use-page-path-data-provider';
import Logo from '../logo';
const PdpHeader = () => {
  const {
    open
  } = useSearchModal();
  const router = useRouter();
  const {
    setCartBackReturnUrl
  } = useCartReturnUrl();
  const {
    prevPath
  } = usePagePathDataProvider();
  const goBack = () => {
    if (prevPath === 'base') router.push('/');else router?.back();
  };
  return <div className='flex flex-1 items-center justify-between' data-sentry-component="PdpHeader" data-sentry-source-file="pdp-header.tsx">
            <div className='flex flex-1 items-center'>
                <IconArrowRight1 className='inline h-6 w-6 cursor-pointer text-text-black' onClick={goBack} data-sentry-element="IconArrowRight1" data-sentry-source-file="pdp-header.tsx" />
                <Logo data-sentry-element="Logo" data-sentry-source-file="pdp-header.tsx" />
            </div>
            <div className='flex items-center gap-5'>
                <IconSearchNormal className='h-6 w-6' onClick={open} data-sentry-element="IconSearchNormal" data-sentry-source-file="pdp-header.tsx" />
                <AppNextLink href={OrderPagesURL.CART} prefetch={false} aria-label='Cart' onClick={setCartBackReturnUrl} className='flex items-center' data-sentry-element="AppNextLink" data-sentry-source-file="pdp-header.tsx">
                    <CartCounterButton data-sentry-element="CartCounterButton" data-sentry-source-file="pdp-header.tsx" />
                </AppNextLink>
            </div>
        </div>;
};
export default PdpHeader;